@if (loading) {
<div class="loader" [style.background-image]="imgSrc"> </div>
}
